module.exports = __webpack_public_path__ + "NLT-header-logo.b1e9bc1a4fbc94e27b9f.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/NLT-header-logo.svg
// module id = ../../../../../src/img/NLT-header-logo.svg
// module chunks = styles